import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { MePage } from './model';
import { PersonProfilePageView } from 'portcall/personprofilepage/view';
import { LoginView } from 'portcall/login/view';

export const MePageView = SuperCritical(({ model: m } : { model : MePage }) => 
    <div>
        {/* MePage is just a wrapper around PersonProfilePage.
            It's only job is to fish current UserId out of current user. */}
        {(ppp => ppp && 
            <PersonProfilePageView model={ppp} />
        )(m.PersonProfilePage())}
        <LoginView modelContainer={m.Login} />
    </div>
);


// WEBPACK FOOTER //
// ./apps/portcall/mepage/view.tsx